import apiFetch from '../apiFetch'

export default function (token, organizedUnitConfiguration) {
  return apiFetch({ endPoint: 'OrganizedUnitConfiguration', method: 'POST', body: organizedUnitConfiguration, token: token })
}
